import BGReport from './hive-factory';
import config from './model';
import cnConfig from './model.cn';
import globalConfig from '../../global-config';
var pvuvReport;
export function transfer(params) {
    if (!pvuvReport) {
        var isCN = globalConfig.get('isCN');
        pvuvReport = new BGReport(isCN ? cnConfig : config);
    }
    return pvuvReport.format(params);
}
